@if (hasViewPricesCapability()) {
  <lib-fastpay-card-cta></lib-fastpay-card-cta>
}

<div>
  @if (vm().isLoading && vm().items.length === 0) {
    <lib-skeleton-card-table></lib-skeleton-card-table>
    <lib-spinner-loading></lib-spinner-loading>
    <lib-skeleton-card-table></lib-skeleton-card-table>
  } @else if (vm().error && vm().items.length === 0) {
    <div class="ion-text-center ion-padding">
      <p class="fs-sm">{{ 'freight.list.load_error' | translate }}</p>
      <ion-button
        size="small"
        (click)="onRetry()"
        >{{ 'general.retry' | translate }}</ion-button
      >
    </div>
  } @else {
    <lib-infinite-scroll-header [infiniteScrollConfig]="headerConfig()"></lib-infinite-scroll-header>

    @for (freight of vm().items; track freight.id) {
      <lib-freight-carrier-finished-card
        [freight]="freight"
        [attr.id]="freight.id"
      ></lib-freight-carrier-finished-card>
    } @empty {
      <lib-empty-result text="freight.general.without_finished_freights"></lib-empty-result>
    }

    @if (!vm().hasMore && vm().items.length > 0 && !vm().error) {
      <p class="fs-sm ion-text-center ion-padding">
        <strong>{{ 'freight.general.no_more_data' | translate }}</strong>
      </p>
    }

    @if (vm().isLoadingMore) {
      <lib-skeleton-card-table></lib-skeleton-card-table>
      <p class="fs-xs ion-text-center ion-padding">{{ 'general.loading_data' | translate }}</p>
      <lib-skeleton-card-table></lib-skeleton-card-table>
    }

    @if (vm().error && vm().items.length > 0) {
      <div class="ion-text-center ion-padding">
        <p class="fs-xs">{{ 'freight.list.load_error' | translate }}</p>
        <ion-button
          size="small"
          fill="outline"
          (click)="onRetry()"
        >
          {{ 'general.retry' | translate }}
        </ion-button>
      </div>
    }

    @if (vm().hasMore) {
      <ion-infinite-scroll
        position="bottom"
        threshold="136px"
        [disabled]="vm().isLoading || vm().isLoadingMore || vm().isStale || !!vm().error"
        (ionInfinite)="onIonInfinite($event)"
        class="ion-margin-negative"
      >
        <ion-infinite-scroll-content [loadingText]="'general.loading_data' | translate"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    }
  }
</div>
